import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import get from 'lodash/get';

import createAsyncAction from 'shared/utils/createAsyncAction';
import createAction from 'modules/queues/Schedule/actions';
import { CLOSED_APPOINTMENT_STATUSES } from 'modules/common/constants/appointmentStatuses';
import { defaultState } from 'modules/queues/Schedule/reducers/appointmentsFilters';
import { fetchAppointmentById } from 'modules/queues/Schedule/actions/fetchAppointmentById';
import { showAppointmentInfo } from './appointmentInfo';

import * as services from '../../Schedule/services/fetchAppointments';

export const CHECK_CLOSEST_APPOINTMENT = createAsyncAction(createAction('CHECK_CLOSEST_APPOINTMENT'));

export const fetchClosestAppointment = () => {

  const apiCallParams = {
    query: services.FETCH_APPOINTMENTS_IDS_AND_CURSOR,
    fetchPolicy: 'no-cache',
    variables: {
      page: 1,
      perPage: 1,
      sort: defaultState.activeSortField,
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { patientAppointments: { edges } } }) => {

      return get(edges, '[0].appointment.appointmentId', null);
    });
};

export const checkClosestAppointment = (search, ignoreDeepLinkCheck = false) => async (dispatch, getState) => {
  dispatch({ type: CHECK_CLOSEST_APPOINTMENT.pending });

  const state = getState();
  const { hideArchive } = state.common.organizationConfig.appointmentConfig;
  const { redirectPatientToNearestAppointment } = state.common.organizationConfig.generalConfig;
  const { selectedOrganizationToken } = state.auth.organizations;
  const { isAppointmentInfoShown } = state.queues.common.appointmentInfo;

  const params = new URLSearchParams(search);
  const URLAppointmentId = params.get('appointmentId');
  const URLOrganizationId = Number(params.get('orgId'));
  const redirectToList = Boolean(params.get('list'));

  if (redirectToList || !redirectPatientToNearestAppointment
    || (!ignoreDeepLinkCheck && URLAppointmentId && selectedOrganizationToken === URLOrganizationId) || isAppointmentInfoShown) {
    return dispatch({ type: CHECK_CLOSEST_APPOINTMENT.success });
  }

  const closestAppointmentId = await fetchClosestAppointment();

  if (!closestAppointmentId) return dispatch({ type: CHECK_CLOSEST_APPOINTMENT.failure });

  return dispatch(fetchAppointmentById((!ignoreDeepLinkCheck && URLAppointmentId) || closestAppointmentId))
    .then(({ appointment }) => {
      if (appointment && (!CLOSED_APPOINTMENT_STATUSES.includes(appointment.status) || !hideArchive) && appointment.consultationType !== 'MESSAGING') {
        dispatch(showAppointmentInfo(appointment.appointmentId));
      }
      dispatch({ type: CHECK_CLOSEST_APPOINTMENT.success });
    })
    .catch(() => {
      dispatch({ type: CHECK_CLOSEST_APPOINTMENT.failure });
    });
};
